import "./index.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import NoteModal from "../../../components/NoteModal";
import OpenFileModal from "../../../components/Document/OpenFileModal";
import { Box } from "@mantine/core";
import moment from "moment";
import MedicationModal from "../../../components/MedicationModal";

const badgeType = (module) => {
  if (module === "note") return "note";
  if (module === "mar") return "mar";
  if (module === "document") return "document";
  return "task";
};

const badgeLabel = (item) => {
  if (item?.module === "note")
    return item?.moduleId?.fields?.noteType || "Note";
  if (item?.module === "mar") return "MAR";
  if (item?.module === "document") return "Document";
  return "Task";
};

const eventDesc = (item) => {
  const by = item?.createdBy?.name;
  if (item?.module === "note") {
    const noteType = item?.moduleId?.fields?.noteType || "Note";
    const text =
      item?.moduleId?.fields?.Description ||
      item?.moduleId?.fields?.description ||
      "";
    return text || (by ? `${noteType} created by ${by}` : noteType);
  }
  if (item?.module === "mar") {
    const m = item?.moduleId;
    const parts = [
      m?.form3?.medicationName,
      m?.form3?.dosage && m?.form3?.unit
        ? `${m.form3.dosage} ${m.form3.unit}`
        : null,
      m?.form3?.frequency ? `· ${m.form3.frequency}` : null,
      "· marked taken",
    ].filter(Boolean);
    return parts.join(" ");
  }
  if (item?.module === "taskFields" || item?.module === "task") {
    const fields =
      item?.moduleId?.fieldsDone?.map((v) => v?.field?.name).filter(Boolean) ||
      [];
    return fields.length
      ? fields.join(", ")
      : by
      ? `Task completed by ${by}`
      : "Task";
  }
  if (item?.module === "document") {
    return by ? `Document uploaded by ${by}` : "Document uploaded";
  }
  return by ? `Activity by ${by}` : "";
};

const ActivitySide = ({ activities, isActivity }) => {
  const [view, setView] = useState(true);
  const [data, setData] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedMar, setSelectedMar] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);
  const [Fileopened, { open: openFile, close: closeFile }] =
    useDisclosure(false);

  const navigate = useNavigate();

  const compareDate = (date, medicationType, upcoming) => {
    const time1 = moment(date).startOf("day");
    const today = moment().startOf("day");
    if (medicationType === upcoming) return -1;
    if (time1.isSame(today)) return 0;
    if (time1.isAfter(today)) return 1;
    return -1;
  };

  const handleView = (item) => {
    if (item?.module === "taskFields" || item?.module === "task") {
      navigate("/home/view-task", {
        state: { ...item?.moduleId, selectedShift: item?.moduleId?.shift?.[0] },
      });
    } else if (item?.module === "note") {
      setData(item?.moduleId);
      setOpen(true);
    } else if (item?.module === "document") {
      setSelectedFile(item?.moduleId);
      openFile();
    } else if (item?.module === "mar") {
      setSelectedMar(item?.moduleId);
      open();
    }
  };

  return (
    <>
      <NoteModal
        opened={isopen}
        close={() => { setOpen(false); setData(null); }}
        title="Add New Note"
        view={true}
        setView={setView}
        data={data}
      />

      <OpenFileModal
        opened={Fileopened}
        onclose={closeFile}
        title=""
        data={selectedFile}
      />

      {selectedMar && (
        <MedicationModal
          opened={opened}
          onclose={() => { close(); setIsViewOpen(false); }}
          isViewOpen={true}
          setIsViewOpen={setIsViewOpen}
          data={selectedMar}
          futureDate={compareDate(selectedMar?.date)}
          isActivity={isActivity}
        />
      )}

      {!activities || activities.length === 0 ? (
        <Box style={{ color: "#9CA3AF", fontSize: "13px", padding: "4px 0" }}>
          No recent activity
        </Box>
      ) : (
        <ol className="fs-event-list">
          {activities.map((item, index) => {
            const type = badgeType(item?.module);
            const desc = eventDesc(item);
            const deleted = item?.moduleDeleted;
            return (
              <li key={index} className="fs-event">
                <div className="fs-event-top">
                  <span className={`fs-event-badge fs-event-badge-${type}`}>
                    {badgeLabel(item)}
                  </span>
                  <span className="fs-event-time">
                    {moment(item?.createdAt).fromNow()}
                  </span>
                </div>

                {desc ? (
                  <p className="fs-event-desc">{desc}</p>
                ) : null}

                <div className="fs-event-bottom">
                  <div className="fs-event-by">
                    {item?.createdBy?.name}
                    <span className="fs-event-sep" />
                    {moment(item?.createdAt).format("hh:mm a")}
                  </div>
                  <button
                    className="fs-event-view"
                    type="button"
                    disabled={deleted}
                    style={deleted ? { opacity: 0.4, cursor: "default" } : {}}
                    onClick={() => !deleted && handleView(item)}
                  >
                    View
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  </button>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </>
  );
};

export default ActivitySide;
